<div
  class="px-3"
  style="padding-top: 7rem; padding-bottom: 7rem">
  <p class="font-medium text-2xl mb-1">Для того, чтобы мы смогли создать актуальную рассылку,</p>
  <p class="font-medium text-2xl mb-3">пожалуйста, скачайте файл и заполните его по шаблону.</p>
  <p class="font-medium text-2xl">Затем загрузите заполненный файл с вашими данными.</p>

  <div class="mt-6">
    <div class="flex justify-content-center gap-7">
      <crm-button
        type="button"
        label="Скачать файл"
        icon="pi pi-file-excel"
        styleClass="p-button-success p-button-lg"
        style="min-width: 170px !important; max-width: 170px !important"
        (onClick)="downloadClick()"></crm-button>

      <crm-file-uploader
        #fileUpload
        [isUploadFiles]="false"
        [uploadingFiles]="loading"
        (filesSelected)="selectedFileDebtor($event)"
        style="min-width: 170px !important; max-width: 170px !important"
        styleClass="p-button-lg"
        label="Загрузить файл"></crm-file-uploader>
    </div>
  </div>
</div>
